import { EnterpriseFormDefaultValues, EnterpriseFormType } from "./EnterpriseForm"
import { LegalPersonFormDefaultValues, LegalPersonFormType } from "./LegalPersonForm"
import { PricingFormType } from "./PricingForm"
import {
  StepAddSubscription,
  StepEntreprise,
  StepLegalPerson,
} from "@/constants/lazyLoad/lazyClients"
import { SubscriptionFormDefaultValues } from "@/types/SubscriptionsType"
import { StepType } from "components/common/stepper/CustomStepper"

export type AllStepFormType =
  | EnterpriseFormType
  | LegalPersonFormType
  | PricingFormType

// export const STEPS = ["Entreprise", "Représentant légal"]
export const clientAddSteps = [
  { label: "Entreprise", link: "" },
  { label: "Représentant légal", link: "representant-legal" },
]

export const CLIENT_ADD_STEPS : StepType[] = [
  {
    id:1,
    pathName: "",
    name: "Entreprise",
    component: StepEntreprise,
  },
  {
    id:2,
    pathName: "representant-legal",
    name: "Représentant légal",
    component: StepLegalPerson,
  },
  {
    id: 3,
    pathName: "subscription",
    name: "Abonnement",
    component: StepAddSubscription
  }
]

export type StepFieldMatchNameType = {
  [P in keyof EnterpriseFormType]: string
} & {
  [P in keyof LegalPersonFormType]: string
}

export const AllDefaultValues = [
  EnterpriseFormDefaultValues,
  LegalPersonFormDefaultValues,
  SubscriptionFormDefaultValues
]


